import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import PageContent from './components/Content';

export default () => (
  <Container className='dashboard'>
    <Row>
      <Col md={12}>
        <h3 className='page-title'>Car Spec Data</h3>
      </Col>
    </Row>
    <Row>
      <PageContent />
    </Row>
  </Container>
);
